/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Social_Export_Publish_SuccessInputs */

const cs_social_export_publish_success = /** @type {(inputs: Social_Export_Publish_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publikováno na ${i?.platform}.`)
};

const en_social_export_publish_success = /** @type {(inputs: Social_Export_Publish_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published to ${i?.platform}.`)
};

/**
* | output |
* | --- |
* | "Published to {platform}." |
*
* @param {Social_Export_Publish_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_publish_success = /** @type {((inputs: Social_Export_Publish_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Publish_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_publish_success(inputs)
	return cs_social_export_publish_success(inputs)
});